<app-home-header></app-home-header>
<app-opening></app-opening>
<app-intro></app-intro>
<app-location></app-location>
<app-event-slider></app-event-slider>
<app-blog-slider></app-blog-slider>
<app-review-slider></app-review-slider>
<app-steeldart></app-steeldart>
<app-teams></app-teams>
<app-team-action></app-team-action>
<app-home-faq></app-home-faq>
<app-footer></app-footer>
